export default "__VITE_ASSET__BkVZLz9E__"